import { Typography } from "@mui/material";
import { isNull } from "lodash";
import BooleanLabel from "./BooleanLabel";

const InfoLabel = ({ title, content }) => {
  return (
    (!(isNull(title) || typeof(title)=="undefined")) && <Typography sx={{ fontSize: "14px", lineHeight: "24px" ,display:"flex",gap:0.5,alignItems:"center"}}>
      <div
        style={{
          fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
          fontWeight: "400",
        }}
      >
        {title}
      </div>
      <div
        style={{
          fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
          fontWeight: "500",
        }}
      >
        {
          (isNull(content) || typeof(content)=="undefined") ? 
            "None" 
          : typeof(content)=="boolean" ? 
            <BooleanLabel bool={content} />
          : content}
      </div>
    </Typography>
  );
};

export default InfoLabel;
